<div class="grid">
    <div class="col-12" *ngIf="!permissaoInserir">
        <div class="card">
            <div style="text-align: center">
                <h4>Você não possui permissão de acesso essa página!</h4>
            </div>
        </div>
    </div>
    <div class="col-12" *ngIf="permissaoInserir">
        <div class="card" *ngIf="loadingPrincipal">
            <div class="flex justify-content-center">
                <p-progressSpinner></p-progressSpinner>
            </div>
        </div>
        <div class="card" *ngIf="!loadingPrincipal">
            <div class="w-full">
                <p-messages
                    [(value)]="messages"
                    [enableService]="false"
                    [closable]="true"
                ></p-messages>
            </div>
            <div class="flex justify-content-center mb-2" *ngIf="sucessoSalvar">
                <span class="border-1 border-round border-400 font-semibold p-1">
                    <a [routerLink]="linkEditar">Ver dados salvos</a>
                </span>
            </div>
            <form (keypress)="ocultarMensagem()" #f="ngForm" name="form" novalidate>
                <div class="p-fluid p-formgrid grid">
                    <div class="field col-12 md:col-2">
                        <label htmlFor="nfEntrada">Nº Entrada</label>
                        <input
                            type="number"
                            pInputText
                            name="nfEntrada"
                            #nfEntrada="ngModel"
                            [(ngModel)]="entradaEstoque.nfEntrada"
                        />
                    </div>
                    <div class="field col-12 md:col-2">
                        <label htmlFor="dataNf">Data Entrada</label>
                        <p-calendar
                            [showIcon]="true"
                            [showOnFocus]="false"
                            dateFormat="dd/mm/yy"
                            [showButtonBar]="true"
                            name="dataNf"
                            #dataNf="ngModel"
                            [required]="true"
                            [(ngModel)]="entradaEstoque.dataNf"
                        ></p-calendar>
                    </div>
                    <div class="field col-12 md:col-4">
                        <label htmlFor="fornecedor">Fornecedor</label>
                        <p-dropdown
                            [options]="listaFornecedores"
                            optionLabel="nomeFornecedor"
                            placeholder="Selecione"
                            name="fornecedor"
                            #fornecedor="ngModel"
                            [required]="true"
                            [(ngModel)]="entradaEstoque.fornecedor"
                        ></p-dropdown>
                    </div>
                    <div class="field col-12 md:col-2">
                        <label htmlFor="valorFrete">Valor do Frete</label>
                        <p-inputNumber
                            name="valorFrete"
                            mode="currency"
                            inputId="currency-brazil"
                            currency="BRL"
                            locale="pt-BR"
                            [allowEmpty]="false"
                            [(ngModel)]="entradaEstoque.valorFrete"
                            #valorFrete="ngModel"
                            (ngModelChange)="atribuirTotalNf()"
                        ></p-inputNumber>
                    </div>
                    <div class="field col-12 md:col-2">
                        <label htmlFor="totalNf">Total Entrada</label>
                        <p-inputNumber
                            name="totalNf"
                            mode="currency"
                            inputId="currency-brazil"
                            currency="BRL"
                            locale="pt-BR"
                            [allowEmpty]="false"
                            [(ngModel)]="entradaEstoque.totalNf"
                            #totalNf="ngModel"
                            [required]="true"
                        ></p-inputNumber>
                        <div *ngIf="valorFrete.value > 0 && totalNf.value <= 0" class="alerta">
                            <small>Campo obrigatório</small>
                        </div>
                    </div>

                    <div class="field col-12 md:col-4">
                        <button
                            pButton
                            pRipple
                            label="Adicionar"
                            pTooltip="Adicionar item a nota de entrada"
                            class="p-button-outlined w-full md:w-9rem"
                            icon="pi pi-plus"
                            style="box-shadow: none"
                            type="button"
                            (click)="abrirDialogProduto()"
                        ></button>
                    </div>
                </div>
            </form>
            <div class="p-fluid">
                <p-table
                    #tabelaListaEntradaAdicionadas
                    [value]="listaEntradaProduto"
                    dataKey="id"
                    [rowTrackBy]="trackByFn"
                    [rows]="10"
                    [rowHover]="true"
                    [paginator]="false"
                    responsiveLayout="scroll"
                    styleClass=" p-datatable-sm"
                >
                    <ng-template pTemplate="header">
                        <tr>
                            <th>
                                <div>Código</div>
                            </th>
                            <th>
                                <div>Descrição</div>
                            </th>
                            <th>
                                <div>Estoque Atual</div>
                            </th>
                            <th>
                                <div>Quantidade</div>
                            </th>
                            <th>
                                <div>Valor de Compra</div>
                            </th>
                            <th>
                                <div>Valor de Venda</div>
                            </th>
                            <th>
                                <div>Validade</div>
                            </th>
                            <th>
                                <div>Total</div>
                            </th>

                            <th>
                                <div>Excluir</div>
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-item let-i="rowIndex">
                        <tr>
                            <td>
                                <label>{{ item.itemProduto.codigo }}</label>
                            </td>
                            <td>
                                <label>{{ item.itemProduto.descricao }}</label>
                            </td>
                            <td>
                                <label>
                                    {{ item.itemProduto.estoqueAtual }}
                                    {{ item.itemProduto.descricaoUnidadeMedida }}
                                </label>
                            </td>
                            <td>
                                <input
                                    type="number"
                                    pInputText
                                    [(ngModel)]="item.quantidade"
                                    (ngModelChange)="onItemChange(item)"
                                />
                            </td>
                            <td>
                                <p-inputNumber
                                    [(ngModel)]="item.valorCompra"
                                    mode="currency"
                                    inputId="currency-brazil"
                                    currency="BRL"
                                    locale="pt-BR"
                                    [allowEmpty]="false"
                                    (ngModelChange)="onItemChange(item)"
                                ></p-inputNumber>
                            </td>
                            <td>
                                <p-inputNumber
                                    [(ngModel)]="item.itemProduto.valorVenda"
                                    mode="currency"
                                    inputId="currency-brazil"
                                    currency="BRL"
                                    locale="pt-BR"
                                    [allowEmpty]="false"
                                    (onFocus)="
                                        exibirOverlayValorSugerido($event, overlayValorVenda, item)
                                    "
                                    (onBlur)="overlayValorVenda.hide()"
                                ></p-inputNumber>
                            </td>
                            <td>
                                <p-inputMask
                                    mask="99/99/9999"
                                    [(ngModel)]="item.validadeLote"
                                    placeholder="DD/MM/AAAA"
                                    slotChar="DD/MM/YYYY"
                                    [unmask]="false"
                                ></p-inputMask>
                            </td>
                            <td>
                                <label for="">
                                    {{ item.valorCompra * item.quantidade | currency: "BRL" }}
                                </label>
                            </td>

                            <td>
                                <button
                                    pButton
                                    pRipple
                                    pTooltip="Excluir"
                                    type="button"
                                    icon="pi pi-trash"
                                    class="p-button-danger"
                                    (click)="excluirProduto(item)"
                                ></button>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="summary">
                        <div class="flex align-items-center justify-content-between">
                            <div>
                                Há
                                {{ listaEntradaProduto ? listaEntradaProduto.length : 0 }}
                                produtos inseridos na nota.
                            </div>
                            <div>Total: {{ totalItens | currency: "BRL" }}</div>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="9">Nenhum registro cadastrado.</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
            <div class="p-fluid p-formgrid grid justify-content-between mt-2">
                <div class="col-12 md:col-4">
                    <button
                        *ngIf="!progressoRequisicao; else exibirBotaoFalso"
                        type="button"
                        pButton
                        icon="pi pi-check"
                        label="Salvar"
                        class="p-button-outlined p-button-success md:w-9rem"
                        [disabled]="!f.valid"
                        (click)="salvar()"
                    ></button>
                    <ng-template #exibirBotaoFalso>
                        <button
                            type="button"
                            pButton
                            icon="pi pi-spin pi-spinner"
                            label="Salvar"
                            class="p-button-outlined p-button-success md:w-9rem"
                            disabled
                        ></button>
                    </ng-template>
                </div>
                <div class="col-12 md:col-4 flex justify-content-end">
                    <button
                        type="button"
                        pButton
                        icon="pi pi-arrow-left"
                        label="Voltar"
                        class="p-button-outlined md:w-9rem"
                        routerLink="/apps/entrada"
                    ></button>
                </div>
            </div>

            <p-overlayPanel #overlayValorVenda appendTo="body">
                <ng-template pTemplate>
                    <div class="flex flex-row align-items-center gap-2">
                        <span class="font-medium text-900">
                            Sugerido: {{ valorVendaSugerido | currency: "BRL" }}
                        </span>
                        <button
                            type="button"
                            pButton
                            icon="pi pi-check"
                            class="p-button-success"
                            (click)="fecharOverlayValorSugerido()"
                        ></button>
                    </div>
                </ng-template>
            </p-overlayPanel>
        </div>
    </div>
</div>
<p-dialog
    header="Adicionar Produto"
    [(visible)]="mostrarDialogProduto"
    [breakpoints]="{ '960px': '75vw', '640px': '90vw' }"
    [style]="{ width: '50vw' }"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [closable]="true"
>
    <ng-template pTemplate="content">
        <p-table
            #tabelaListaProduto
            [value]="listaProdutosDisponiveis"
            dataKey="id"
            [loading]="loadingTableProdutosDisponiveis"
            [rows]="10"
            [rowHover]="true"
            styleClass="p-datatable-gridlines"
            [paginator]="true"
            responsiveLayout="scroll"
            styleClass=" p-datatable-sm"
            [globalFilterFields]="['codigo', 'descricao']"
        >
            <ng-template pTemplate="caption">
                <div class="flex justify-content-end flex-column sm:flex-row">
                    <div class="p-fluid">
                        <div class="flex">
                            <span class="p-input-icon-left w-full">
                                <i class="pi pi-search"></i>
                                <input
                                    pInputText
                                    type="text"
                                    #filter
                                    (input)="buscar(tabelaListaProduto, $event)"
                                    placeholder="Buscar"
                                />
                            </span>
                            <span class="ml-2">
                                <button
                                    pButton
                                    class="p-button-outlined"
                                    icon="pi pi-filter-slash"
                                    pTooltip="Limpar Filtros"
                                    (click)="limpar(tabelaListaProduto)"
                                ></button>
                            </span>
                        </div>
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="codigo">
                        <div>Código</div>
                    </th>
                    <th pSortableColumn="descricao">
                        <div>Descrição</div>
                    </th>

                    <th style="text-align: center">
                        <div>Adicionar</div>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item let-i="rowIndex">
                <tr>
                    <td>
                        <label>{{ item.codigo }}</label>
                    </td>
                    <td>
                        <label>{{ item.descricao }}</label>
                    </td>

                    <td style="text-align: center">
                        <button
                            pButton
                            pRipple
                            type="button"
                            icon="pi pi-check"
                            class="p-button-success"
                            pTooltip="adicionar"
                            (click)="adicionarProduto(item)"
                        ></button>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="summary">
                <div class="flex align-items-center justify-content-between">
                    Há
                    {{ listaProdutosDisponiveis ? listaProdutosDisponiveis.length : 0 }}
                    produtos disponíveis.
                </div>
            </ng-template>
        </p-table>
    </ng-template>
</p-dialog>
